import styled from "styled-components";
import { viewSizeCalculator } from "../../utils";

export const Container = styled.div`
  padding: ${() =>
    `${viewSizeCalculator(0.625)} ${viewSizeCalculator(
      0.625,
    )}`}; // 0.625rem 1.25rem;

  border-radius: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem
  background-color: #ffffff;

  box-shadow: 0rem 0.0625rem 0.3125rem 0rem #3333331a;
`;

export const PublicationContainer = styled(Container)`
  padding: ${() =>
    `${viewSizeCalculator(1.25)} ${viewSizeCalculator(
      1.25,
    )}`}; // 0.625rem 1.25rem;
`;

export const Title = styled.span`
  font-family: Inter;
  font-weight: 700;
  font-size: ${() => `${viewSizeCalculator(0.913)}`};
  line-height: ${() => `${viewSizeCalculator(1)}`};
  color: #333333;
  text-align: left;
`;

export const TitleSuffix = styled.span`
  font-family: Inter;
  font-weight: 700;
  font-size: ${() => `${viewSizeCalculator(1)}`};
  line-height: ${() => `${viewSizeCalculator(1.25)}`};
  color: #333333;
  opacity: 60%;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${() => `${viewSizeCalculator(0.625)}`};
`;

export const PublicationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${() => `${viewSizeCalculator(0.5)}`};
  //   border: 1px solid red;
`;

export const Publications = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${() => `${viewSizeCalculator(0.75)}`};
  //   border: 1px solid red;
  padding: ${() =>
    `${viewSizeCalculator(1.5)} ${viewSizeCalculator(0)}`}; // 0.625rem 1.25rem;
`;

export const PublicationDetails = styled.span`
  font-family: Inter;
  font-weight: 400;
  font-size: ${() => `${viewSizeCalculator(1)}`};
  line-height: ${() => `${viewSizeCalculator(1.25)}`};
  color: #333333;
  margin-bottom: ${() => `${viewSizeCalculator(0.5)}`};
`;

export const PopupFooter = styled.div`
  margin-top: auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ViewAllButtonWrapper = styled.span`
  display: flex;
  gap: ${() => `${viewSizeCalculator(0.125)}`};
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const ViewAllContent = styled.div`
  font-size: ${() => `${viewSizeCalculator(0.725)}`};
  font-weight: 600;
  line-height: ${() => `${viewSizeCalculator(0.75)}`};
  opacity: 30%;
  color: #333;
`;

export const PlayButtonWrapper = styled.div`
  position: relative;
  svg {
    position: absolute;
    top: ${() => `${viewSizeCalculator(-0.3125)}`};
    width: ${() => `${viewSizeCalculator(0.625)}`};
    height: ${() => `${viewSizeCalculator(0.625)}`};
  }
`;
